<template>
  <div class="section-map-comp">
    <div class="row">
      <div
        class="col s2"
        v-for="(section, index) in sections"
        :key="`${$route.name}_sectionmapindex_${index}`"
      >
        <div
          :class="index <= currentSection ? `SM-index active` : `SM-index`"
          @click="() => selectSection(index)"
        >
          {{ section }}
        </div>
      </div>
    </div>
    <hr />
    <hr :id="`${$route.name}_sectionMapProgress`" class="SM-progress-bar" />
  </div>
</template>

<script>
export default {
  name: "SectionMap",
  props: {
    sections: {
      type: Array,
      default() {
        return [1, 2, 3, 4, 5, 6];
      },
    },
    currentSection: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {};
  },
  methods: {
    selectSection(index) {
      this.currentSection = index;
      this.progressUpdate(index);
      this.$emit("event", this.currentSection);
    },
    progressUpdate(index) {
      let progress = document.getElementById(
        `${this.$route.name}_sectionMapProgress`
      );
      progress.style.width = `${((index + 1 - 1) / (6 - 1)) * 90}%`;
    },
  },
};
</script>

<style lang="scss">
.section-map-comp {
  max-width: 600px;

  .row .col {
    padding: 0;
  }

  .SM-index {
    width: 40px;
    height: 40px;
    background: #ececec;
    font-size: 20px;
    text-align: center;
    border-radius: 50%;
    padding-top: 4px;
    position: relative;
    z-index: 5;
    color: white;
    cursor: pointer;

    &.active {
      background: #bfe0f7;
      color: #15243c;
    }
  }

  hr {
    position: relative;
    top: -42px;
    height: 5px;
    border: 0;
    background: #ececec;
    width: 90%;
    margin: 0;
    left: 0%;

    &.SM-progress-bar {
      background: #a0cceb;
      top: -47px;
      width: 0;
    }
  }
}
</style>